import { Inject, Injectable, makeStateKey, PLATFORM_ID, TransferState } from '@angular/core';
import { Observable } from "rxjs";
import { isPlatformServer } from "@angular/common";
import { HttpLocationService } from "./http/location.service";
import { LocationResponseInterface, StoreViewInterface } from "../models/store";

const LOCATION_KEY = makeStateKey<LocationResponseInterface>('location');

@Injectable({
  providedIn: 'root'
})
export class LocationService {

  constructor(
    @Inject(PLATFORM_ID) private platformId: typeof PLATFORM_ID,
    private transferState: TransferState,
    @Inject(HttpLocationService) private locationHttpService: HttpLocationService,
  ) {
  }

  public static sortLocationsByStorePickupPriority(locations: StoreViewInterface[]) {
    locations.sort((a: StoreViewInterface, b: StoreViewInterface) => {
      if (! a.storePickupPossible && ! b.storePickupPossible) return 0

      if (! a.storePickupPossible && b.storePickupPossible) return 1
      if (a.storePickupPossible && ! b.storePickupPossible) return -1

      if (a.storePickupPossible && b.storePickupPossible) {
        if (a.stock == b.stock) return 0
        if (a.stock < b.stock) return 1
        if (a.stock > b.stock) return -1
      }

      return 0
    })
  }

  getLocation(slug: string): Observable<LocationResponseInterface> {
    let obs: Observable<LocationResponseInterface>

    // check ssr
    if (this.transferState.hasKey(LOCATION_KEY)) {
      let location = this.transferState.get<LocationResponseInterface | undefined>(LOCATION_KEY, undefined)
      if (location) {

        obs = new Observable<LocationResponseInterface>((subscriber) => {
          subscriber.next(location)
        })

        this.transferState.remove(LOCATION_KEY)

        return obs
      }
    }

    // fetch if not in ssr
    obs = this.locationHttpService.getLocation(slug)

    return new Observable<LocationResponseInterface>(subscriber => {
      obs.subscribe(location => {
        if (isPlatformServer(this.platformId)) {
          this.transferState.set(LOCATION_KEY, location)
        }
        subscriber.next(location)
      })
    })
  }
}
